module.exports = __webpack_public_path__ + "img/connects.69cc7531.png";